import type { User } from '#shared/model/user'
import { generateVirtualId } from '../misc/generate-virtual-id'

export function createPlaceholderUser(): User {
  return {
    avatarUrl: null,
    displayName: 'User',
    id: generateVirtualId(),
    joinedAt: new Date().toISOString(),
    totalMessagesCount: 0,
    bans: [],
    login: '',
    isAdmin: false,
  }
}
